import { RuleSet } from '../Components/Options';
import { InputType } from '../types';

export const ListFormatInput: InputType = [
	{ value: '["apple", "banana", "lemon"]', type: 'string' }
];

export const ListFormatRuleSet: RuleSet = [
	{
		type: 'condition',
		predicate: {
			property: 'style',
			values: ['short', 'narrow']
		},
		implication: {
			property: 'type',
			allowedValues: ['unit']
		}
	},
	{
		type: 'condition',
		predicate: {
			property: 'type',
			values: ['conjunction', 'disjunction']
		},
		implication: {
			property: 'style',
			allowedValues: ['long']
		}
	}
];
